// src/views/Registration/components/Salones/CreateSalones.tsx
import React, { useState } from 'react';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Form, Alert, DropdownButton, Dropdown, Row, Col } from 'react-bootstrap';
import { ChevronLeft, ChevronRight } from 'react-bootstrap-icons';
import './CreateSalones.scss';

interface CreateSalonesProps {
  index: number;
  moveFunctions: {
    next: () => void;
    back: () => void;
  };
  setPayload: (data: any) => void;
  code: string;
  ambientes?: { name: string; mesas: number }[];
  setAmbientes?: React.Dispatch<React.SetStateAction<{ name: string; mesas: number }[]>>;
  numAmbientes?: number;
  setNumAmbientes?: React.Dispatch<React.SetStateAction<number>>;
}

const CreateSalones: React.FC<CreateSalonesProps> = ({ moveFunctions, setPayload, code, ambientes = [], setAmbientes, numAmbientes = 0, setNumAmbientes }) => {
  const [error, setError] = useState<string | null>(null);
  const MAX_MESAS = 12;
  const MAX_AMBIENTES = 10;

  // Si se pasan los estados por props, úsalos, si no, crea internos (para compatibilidad)
  const [localAmbientes, localSetAmbientes] = useState<{ name: string; mesas: number }[]>([]);
  const [localNumAmbientes, localSetNumAmbientes] = useState<number>(0);
  const ambientesState = setAmbientes ? ambientes : localAmbientes;
  const setAmbientesState = setAmbientes || localSetAmbientes;
  const numAmbientesState = setNumAmbientes ? numAmbientes : localNumAmbientes;
  const setNumAmbientesState = setNumAmbientes || localSetNumAmbientes;

  const handleSkip = () => {
    const fakePayload = { salones: [], code };
    setPayload(fakePayload);
    moveFunctions.next();
  };

  const handleNumSelect = (n: number) => {
    setNumAmbientesState(n);
    setAmbientesState(Array.from({ length: n }, () => ({ name: '', mesas: 1 })));
    setError(null);
  };

  const handleAmbienteChange = (
    idx: number,
    field: 'name' | 'mesas',
    value: string | number
  ) => {
    const updated = [...ambientesState];
    (updated[idx] as any)[field] = value;
    setAmbientesState(updated);
  };

  const handleNext = () => {
    const invalid = ambientesState.some(a => !a.name.trim() || a.mesas <= 0);
    if (invalid) {
      setError('Todos los ambientes deben tener nombre y al menos 1 mesa.');
      return;
    }
    const fakePayload = { salones: ambientesState, code };
    setPayload(fakePayload);
    moveFunctions.next();
  };

  return (
    <div>
      <div className="logo-container-preg">
        <img
          src="/logos/Recurso 40MEDIOPUNTO.png"
          alt="Logo Mediopunto"
          className="registration-logo-preg"
        />
      </div>
      <div className="info-guide-preg">
        <h2 className="Title-Step-Registration-preg">Salones</h2>
        <p>
          <FontAwesomeIcon icon={faInfoCircle} size="sm" className="info-icon" />{' '}
          Por favor, cuéntanos cuántos ambientes tiene tu local. Si prefieres, puedes saltarte esta sección y continuar.
        </p>
      </div>

      {error && <Alert variant="danger">{error}</Alert>}

      {/* Dropdown de número de ambientes con estructura copiada */}
      <div className='how-many-ambients'>
        <label>¿Cuántos ambientes tiene tu local?</label>
        <DropdownButton
          variant="none"
          className="dropdown-ambientes"
          title={numAmbientesState > 0 ? String(numAmbientesState) : 'Seleccionar'}
        >
          {Array.from({ length: MAX_AMBIENTES }, (_, i) => (
            <Dropdown.Item key={i + 1} onClick={() => handleNumSelect(i + 1)}>
              {i + 1}
            </Dropdown.Item>
          ))}
        </DropdownButton>
      </div>
      <div className="form-create-salones">
        {ambientesState.map((amb, idx) => (
          <Row key={idx} className="form-group-preg align-items-center mb-3">
            <Col>
              <Form.Control
                type="text"
                placeholder="Nombre del salón"
                value={amb.name}
                onChange={e => handleAmbienteChange(idx, 'name', e.target.value)}
                className="input-create-salon"
              />
            </Col>
            <Col xs="auto" className="d-flex align-items-center">
              <span className="span-salones">Cantidad de mesas:</span>
            </Col>
            <Col md="2">
              <Form.Select
                value={amb.mesas > 0 ? amb.mesas : ''}
                onChange={e => handleAmbienteChange(idx, 'mesas', parseInt(e.target.value, 10))}
                className='select-create-salon'
              >
                {Array.from({ length: MAX_MESAS }, (_, i) => (
                  <option key={i + 1} value={i + 1}>
                    {i + 1}
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Row>
        ))}
      </div>

      {/* Botones de navegación */}
      <div className="button-group">
        <Button
          className="BackStep_Registration-preg"
          variant="none"
          onClick={moveFunctions.back}
        >
          <ChevronLeft /> Anterior
        </Button>

        <Button
          className="NextStep_Registration-preg"
          variant="none"
          onClick={handleNext}
        >
          Siguiente <ChevronRight />
        </Button>
      </div>
    </div>
  );
};

export default CreateSalones;